export const hintDelay = 5
export const inventoryCapacity = 3
export const characterType = {
  
  STUDENT : 'STUDENT',
  TEACHER : 'TEACHER'
}
